import { subDays } from 'date-fns';
import { startOfDateUtcInTz } from 'helpers/date.js';
import { DEFAULT_TIME_ZONE } from 'constants/timeZones.js';
import useOrgGeneralSettings from 'pages/GeneralSettings/useOrgGeneralSettings.js';
import useOrgId from 'hooks/useOrgId.js';
import useClientAPI from 'hooks/useClientAPI.jsx';

export const useVodStatsQuery = ({ timeframeDays }, options = {}) => {
  const orgId = useOrgId();
  const { isLoading: isLoadingTimeZone, data: { defaultTimeZone: timeZone = DEFAULT_TIME_ZONE } = {} } = useOrgGeneralSettings();
  const toDate = startOfDateUtcInTz(new Date(), timeZone);
  const fromDate = subDays(toDate, timeframeDays);
  const enabled = !!orgId && !isLoadingTimeZone && (options.enabled ?? true);

  const clientApi = useClientAPI('/stats/vod', {
    params: {
      customerId: orgId,
      timezone: 'UTC',
      fromDate: fromDate.toISOString(),
      toDate: toDate.toISOString(),
    },
    ...options,
    enabled,
  });

  return {
    ...clientApi,
    isLoading: clientApi.isLoading || isLoadingTimeZone,
  };
};
